<template>
  <a-result status="404">
    <h1 class="exception__title" slot="title">404</h1>
    <div class="exception__description" slot="subTitle">
      <p>Whoops!</p>
      <p>Sorry, the {{ resource }} you are looking for does not exists.</p>
    </div>
    <template #extra>
      <router-link :to="{ name: 'Home' }">
        <a-button type="primary">Back to home page</a-button>
      </router-link>
    </template>
  </a-result>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      // required: true,
      default: 'resource',
    },
  },
};
</script>

<style lang="scss" scoped>
.exception {
  &__title {
    color: #434e59;

    font-size: 72px;
    font-weight: 600;
    line-height: 72px;
  }
  &__description {
    color: rgba(0, 0, 0, 0.45);

    font-size: 20px;
    line-height: 28px;
  }
}
</style>
